
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Anasayfa', path: '/' },
    { name: 'Hakkımda', path: '/hakkimda' },
    { name: 'Hizmetler', path: '/hizmetler' },
    { name: 'Eğitimler', path: '/egitimler' },
    { name: 'Ürünler', path: '/urunler' },
    { name: 'Blog', path: '/blog' },
    { name: 'Basında Biz', path: '/basinda-biz' },
    { name: 'SSS', path: '/sss' },
    { name: 'İletişim', path: '/iletisim' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 cursor-pointer">
            <div className="w-12 h-12 bg-primary-dark rounded-lg flex items-center justify-center">
              <img 
                src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/aedf53178de89724821e4a867150a58e.png" 
                alt="Deniz Erin" 
                className="w-10 h-10 object-contain"
              />
            </div>
            <span className="font-serif text-xl font-bold text-primary-dark">
              Deniz Erin
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center">
            {navLinks.map((item, index) => {
              const isActive = location.pathname === item.path;
              return (
                <div key={item.path} className="flex items-center">
                  <Link
                    to={item.path}
                    className={`relative px-2 py-2 text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap group ${
                      isActive 
                        ? 'text-gold' 
                        : 'text-primary-dark hover:text-gold'
                    }`}
                  >
                    {item.name}
                    {/* Underline effect */}
                    <span className={`absolute bottom-0 left-0 w-full h-0.5 bg-gold transition-transform duration-300 origin-left ${
                      isActive ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'
                    }`}></span>
                  </Link>
                  {/* Separator dot */}
                  {index < navLinks.length - 1 && (
                    <div className="w-1 h-1 rounded-full bg-gold/30"></div>
                  )}
                </div>
              );
            })}
            <Link
              to="/randevu"
              className="ml-4 px-6 py-2.5 bg-gold text-primary-dark rounded-full text-sm font-medium hover:shadow-lg hover:shadow-gold/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Randevu Al
            </Link>
            <Link
              to="/sohbet"
              className="ml-3 px-6 py-2.5 bg-primary-dark text-white rounded-full text-sm font-medium hover:shadow-lg hover:shadow-primary-dark/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Sohbet Et
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-primary-dark cursor-pointer"
            aria-label="Menu"
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden bg-white border-t border-gold/20 transition-all duration-300 overflow-hidden ${
          isMobileMenuOpen ? 'max-h-screen' : 'max-h-0'
        }`}
      >
        <div className="px-6 py-4 space-y-3">
          {navLinks.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-2 text-sm font-medium transition-colors duration-300 cursor-pointer ${
                  isActive ? 'text-gold' : 'text-primary-dark hover:text-gold'
                }`}
              >
                {item.name}
              </Link>
            );
          })}
          <Link
            to="/randevu"
            onClick={() => setIsMobileMenuOpen(false)}
            className="block w-full px-6 py-3 bg-gold text-primary-dark rounded-full text-sm font-medium text-center hover:shadow-lg hover:shadow-gold/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Randevu Al
          </Link>
          <Link
            to="/sohbet"
            onClick={() => setIsMobileMenuOpen(false)}
            className="block w-full px-6 py-3 bg-primary-dark text-white rounded-full text-sm font-medium text-center hover:shadow-lg hover:shadow-primary-dark/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Sohbet Et
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
